export default __webpack_public_path__ + "static/media/problema-10.2400529f.webp";